export default __webpack_public_path__ + "static/media/Icon_List_Selected.18899875.svg";